<template>
  <div class="loader-container" v-if="loader.show">
    <img :src="url('/img/icons/loader.svg')" class="loader" alt="Loading" />
    <p v-html="loader.text"></p>
  </div>
</template>
<script>
import { url } from "../../../../helpers";
import { mapGetters } from "vuex";

export default {
  methods: {
    url,
  },
  computed: {
    ...mapGetters({
      loader: "loader/getLoader",
    }),
  },
};
</script>
